import {
  FETCH_UNPUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_PUBLISHED_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_MERCHANDISE_ITEMS_TO_REVIEW_SUCCESS,
  FETCH_CONSIGNER_OPTIONS_SUCCESS,
  BEGIN_MERCHANDISE_REVIEW_SUCCESS,
  FETCH_MERCHANDISE_ITEM_SUCCESS,
  CANCEL_MERCHANDISE_REVIEW,
  CANCEL_MERCHANDISE_REVIEW_SUCCESS,
  SEARCH_MERCHANDISE_PRODUCTS_SUCCESS,
  MATCH_MERCHANDISE_TO_PRODUCT_SUCCESS,
  ON_REVIEW_ITEM_CONDITION_GRADE_SELECT,
  PUBLISH_MERCHANDISE_ITEM_SUCCESS,
  MAKE_MERCHANDISE_DECISION_SUCCESS,
  SHOW_MERCHANDISE_DETAILS_SUCCESS,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SHOW_PRODUCT_ITEM,
  SAVE_PRODUCT_ITEM_SUCCESS,
  SAVE_PRODUCT_ITEM_ERROR,
  FETCH_ITEM_CHANNEL_INFO_SUCCESS,
  FETCH_ITEM_CHANNEL_INFO_ERROR,
  RESET_CHANNEL_INFO,
  UPDATE_MERCHANDISE_FILTER_OPTIONS,
  FETCH_ITEM_NOTES,
  FETCH_ITEM_NOTES_ERROR,
  FETCH_ITEM_NOTES_SUCCESS,
  CLEAR_ITEM_NOTES,
  CREATE_ITEM_NOTES,
  CREATE_ITEM_NOTES_ERROR,
  CREATE_ITEM_NOTES_SUCCESS,
  FETCH_DONATE_MERCHANDISE_ITEMS_SUCCESS,
  FETCH_DONATE_MERCHANDISE_ITEMS_ERROR,
} from "../constants/ActionTypes";
import {
  AVAILABLE_MARKETPLACE_LISTINGS,
  CHANNEL_ITEMS,
  GRADE_BEST,
  QUEUE_STATUS_READY_FOR_REVIEW,
} from "constants/Merchandising";

import { consolidateChannelDetails } from "util/Merchandising";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  loader: true,
  noContentFoundMessage: "No items for review found",
  selectedSectionId: 1,
  filters: {
    productMatched: "ALL",
    consigner: "ALL",
  },
  consignerOptions: [],
  currentReviewItem: null,
  currentReviewItemCalculatedPrice: 0.0,
  channelInfo: [],
  currentMerchandiseItem: null,
  currentReviewItemChannelDefaults: [],
  currentReviewItemConditionGrade: GRADE_BEST,
  currentReviewCanceled: false,
  merchandiseItemsToReviewList: [],
  merchandiseItemsToReviewPageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null,
  },
  merchandiseItemsReviewedList: [],
  merchandiseItemsReviewedPageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null,
  },
  matchLoader: true,
  matchProductFilters: {},
  matchProductKeywordQuery: "",
  matchProductSearchResults: [],
  matchProductSearchPageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null,
  },
  productItemsList: [],
  productItemsPageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null,
  },
  productItem: null,
  donatedItemsList: [],
  donatedItemsPageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null,
  },
  unPublishedFilterOptions: {
    consigner: "ALL",
    searchText: "",
    warehouse: "ALL",
    status: "ALL",
    issue: "ALL",
  },
  donatedFilterOptions: {
    consigner: 'ALL',
    searchText: '',
    warehouse: 'ALL',
    status: 'ALL',
    issue: 'ALL'
  },
  publishedFilterOptions: {
    consigner: "ALL",
    searchText: "",
    status: "ALL",
    daysPublished: {
      value: "ANY",
      days: null,
    }
  },
  notes: [],
  loadingNotes: false,
};

const DISCOUNT_DEFAULTS = {
  good: 0.5,
  better: 0.3,
  best: 0.2,
};

const roundPrice = (number) => {
  return Number(number.toFixed(2));
};

const calculatePrice = (
  listPrice,
  conditionGrade,
  discountDefaults = DISCOUNT_DEFAULTS,
  discountOverstock = 0.0
) => {
  let discount = discountDefaults[conditionGrade.toLowerCase()];
  if (!discount && (conditionGrade.toLowerCase() === "overstock" || conditionGrade.toLowerCase() === "new")) {
    discount = discountOverstock;
  }
  if (discount) {
    return roundPrice(listPrice * (1.0 - discount));
  } else {
    return 0.0;
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_MERCHANDISE_ITEM_SUCCESS: {
      const listPrice = action.payload?.matchedProductInfo?.listPrice || 0.0;
      const { channelInfo: productChannelInfo = [], itemChannelInfo = [] } =
        action.payload || {};
      const { discountOverstock, discountDefaults = null, channelsConfig = [] } =
        action.payload?.consignerSettings || {};
      return {
        ...state,
        loader: false,
        currentReviewItem: action.payload,
        channelInfo: consolidateChannelDetails({
          defaultChannels: AVAILABLE_MARKETPLACE_LISTINGS,
          defaultChannelInfo: CHANNEL_ITEMS,
          channelsConfig,
          productChannelInfo,
          itemChannelInfo,
        }),
        currentReviewItemCalculatedPrice: calculatePrice(
          listPrice,
          state.currentReviewItemConditionGrade,
          discountDefaults,
          discountOverstock
        ),
      };
    }
    case FETCH_ITEM_CHANNEL_INFO_SUCCESS: {
      const {
        itemChannelInfo = [],
        consignerSettings: { channelsConfig = [] } = {},
      } = action.payload || {};

      return {
        ...state,
        channelInfo: consolidateChannelDetails({
          defaultChannels: AVAILABLE_MARKETPLACE_LISTINGS,
          defaultChannelInfo: CHANNEL_ITEMS,
          channelsConfig,
          itemChannelInfo,
        }),
      };
    }
    case FETCH_ITEM_CHANNEL_INFO_ERROR: {
      return {
        ...state,
        channelInfo: INIT_STATE.channelInfo,
      };
    }
    case RESET_CHANNEL_INFO: {
      return {
        ...state,
        channelInfo: INIT_STATE.channelInfo,
      };
    }
    case FETCH_UNPUBLISHED_MERCHANDISE_ITEMS_SUCCESS: {
      return {
        ...state,
        loader: false,
        merchandiseItemsReviewedList: action.payload.items || [],
        merchandiseItemsReviewedPageInfo: action.payload,
      };
    }
    case FETCH_PUBLISHED_MERCHANDISE_ITEMS_SUCCESS: {
      return {
        ...state,
        loader: false,
        productItemsList: action.payload.items || [],
        productItemsPageInfo: action.payload,
      };
    }
    case FETCH_DONATE_MERCHANDISE_ITEMS_SUCCESS: {
      return {
        ...state,
        loader: false,
        donatedItemsList: action.payload.items || [],
        donatedItemsPageInfo: action.payload,
      };
    }
    case FETCH_DONATE_MERCHANDISE_ITEMS_ERROR: {
      return {
        ...state,
        loader: false,
        donatedItemsList: INIT_STATE.donatedItemsList,
        donatedItemsPageInfo: INIT_STATE.donatedItemsPageInfo,
      };
    }
    case FETCH_MERCHANDISE_ITEMS_TO_REVIEW_SUCCESS: {
      return {
        ...state,
        loader: false,
        merchandiseItemsToReviewList: action.payload.items || [],
        merchandiseItemsToReviewPageInfo: action.payload,
      };
    }
    case FETCH_CONSIGNER_OPTIONS_SUCCESS: {
      return {
        ...state,
        consignerOptions: action.payload,
      };
    }
    case ON_REVIEW_ITEM_CONDITION_GRADE_SELECT: {
      const optionValue = action.payload;
      const listPrice =
        state.currentReviewItem?.matchedProductInfo?.listPrice || 0.0;
      const discountDefaults =
        state.currentReviewItem?.consignerSettings?.discountDefaults;
      const discountOverstock = state.currentReviewItem?.consignerSettings?.discountOverstock;
      return {
        ...state,
        currentReviewItemConditionGrade: optionValue,
        currentReviewItemCalculatedPrice: calculatePrice(
          listPrice,
          optionValue,
          discountDefaults,
          discountOverstock
        ),
      };
    }
    case BEGIN_MERCHANDISE_REVIEW_SUCCESS: {
      const listPrice = action.payload?.matchedProductInfo?.listPrice || 0.0;
      const { channelInfo: productChannelInfo = [], itemChannelInfo = [] } =
        action.payload || {};
      const { discountOverstock, discountDefaults = null, channelsConfig = [] } =
        action.payload?.consignerSettings || {};
      return {
        ...state,
        loader: false,
        currentReviewCanceled: false,
        currentReviewItem: action.payload,
        channelInfo: consolidateChannelDetails({
          defaultChannels: AVAILABLE_MARKETPLACE_LISTINGS,
          defaultChannelInfo: CHANNEL_ITEMS,
          channelsConfig,
          productChannelInfo,
          itemChannelInfo,
        }),
        currentReviewItemCalculatedPrice: calculatePrice(
          listPrice,
          state.currentReviewItemConditionGrade,
          discountDefaults,
          discountOverstock
        ),
        currentReviewItemConditionGrade: GRADE_BEST,
      };
    }
    case CANCEL_MERCHANDISE_REVIEW: {
      return {
        ...state,
        currentReviewCanceled: true,
        loader: false,
        currentReviewItem: null,
        currentReviewItemCalculatedPrice: 0.0,
        currentReviewItemConditionGrade: GRADE_BEST,
      };
    }
    case CANCEL_MERCHANDISE_REVIEW_SUCCESS: {
      const canceledItem = action.payload;
      // replace item in lists with updated item
      const newProps = {
        claimedBy: null,
        claimedAt: null,
        queueStatus: QUEUE_STATUS_READY_FOR_REVIEW,
      };
      const filteredList = state.merchandiseItemsToReviewList.map((item) =>
        item.id === canceledItem.id.value ? { ...item, ...newProps } : item
      );
      return {
        ...state,
        loader: false,
        currentReviewCanceled: false,
        currentReviewItem: null,
        currentReviewItemCalculatedPrice: 0.0,
        currentReviewItemConditionGrade: GRADE_BEST,
        merchandiseItemsToReviewList: filteredList,
      };
    }
    case SEARCH_MERCHANDISE_PRODUCTS_SUCCESS: {
      return {
        ...state,
        matchLoader: false,
        matchProductSearchResults: action.payload.items,
        matchProductSearchPageInfo: action.payload,
      };
    }
    case MATCH_MERCHANDISE_TO_PRODUCT_SUCCESS: {
      const listPrice = action.payload?.matchedProductInfo?.listPrice || 0.0;
      const discountDefaults =
        action.payload?.consignerSettings?.discountDefaults;
      const discountOverstock =
        action.payload?.consignerSettings?.discountOverstock;
      return {
        ...state,
        loader: false,
        currentReviewItem: action.payload,
        currentReviewItemCalculatedPrice: calculatePrice(
          listPrice,
          state.currentReviewItemConditionGrade,
          discountDefaults,
          discountOverstock
        ),
      };
    }
    case PUBLISH_MERCHANDISE_ITEM_SUCCESS: {
      return {
        ...state,
        loader: false,
        currentReviewItem: null,
        currentReviewItemCalculatedPrice: 0.0,
        currentReviewItemConditionGrade: GRADE_BEST,
      };
    }
    case MAKE_MERCHANDISE_DECISION_SUCCESS: {
      return {
        ...state,
        loader: false,
        currentReviewItem: null,
        currentReviewItemCalculatedPrice: 0.0,
        currentReviewItemConditionGrade: GRADE_BEST,
      };
    }
    case SHOW_MERCHANDISE_DETAILS_SUCCESS: {
      return {
        ...state,
        loader: false,
        currentMerchandiseItem: action.payload,
      };
    }
    case SHOW_PRODUCT_ITEM: {
      const id = action.payload;
      const pi = state.productItemsList.find((pi) => pi.id == id);
      return {
        ...state,
        loader: false,
        productItem: pi,
      };
    }
    case SAVE_PRODUCT_ITEM_SUCCESS: {
      return {
        ...state,
        loader: false,
        productItem: null,
      };
    }
    case SAVE_PRODUCT_ITEM_ERROR : {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload?.message || "Failed to save product item",
        showMessage: true,
        productItem: null,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    case UPDATE_MERCHANDISE_FILTER_OPTIONS: {
      switch (action.payload.type) {
        case 'UNPUBLISHED':
          return {
            ...state,
            unPublishedFilterOptions: {
              ...state.unPublishedFilterOptions,
              ...action.payload.value
            }
          };
        case 'PUBLISHED':
          return {
            ...state,
            publishedFilterOptions: {
              ...state.publishedFilterOptions,
              ...action.payload.value
            }
          };
        case 'DONATED':
          return {
            ...state,
            donatedFilterOptions: {
              ...state.donatedFilterOptions,
              ...action.payload.value
            }
          };
      }
    }
    case FETCH_ITEM_NOTES: {
      return {
        ...state,
        loadingNotes: true,
      };
    }
    case FETCH_ITEM_NOTES_ERROR: {
      return {
        ...state,
        loadingNotes: false,
      };
    }
    case FETCH_ITEM_NOTES_SUCCESS: {
      return {
        ...state,
        loadingNotes: false,
        notes: action.payload,
      };
    }
    case CLEAR_ITEM_NOTES: {
      return {
        ...state,
        notes: [],
      };
    }
    case CREATE_ITEM_NOTES: {
      return {
        ...state,
        loadingNotes: true,
      };
    }
    case CREATE_ITEM_NOTES_ERROR: {
      return {
        ...state,
        loadingNotes: false,
      };
    }
    case CREATE_ITEM_NOTES_SUCCESS: {
      return {
        ...state,
        loadingNotes: false,
      };
    }
    default:
      return state;
  }
};
